/**
 * paperFormat.ts
 * Paper-size formatting helpers shared between the printer profile panel and
 * the wizard's preview context bar. Kept out of the component so the wizard
 * doesn't import a UI component just to format a label.
 */
import type { CustomPaperMm, Orientation, PaperSize } from "@/types/print";

export interface CurrentPaper {
  paperSize: PaperSize;
  orientation: Orientation;
  customMm?: CustomPaperMm;
}

export const PAPER_LABELS: Record<PaperSize, string> = {
  A4: "A4",
  A5: "A5",
  A6: "A6",
  Letter: "Letter",
  Legal: "Legal",
  Thermal80: "Nhiệt 80mm",
  Custom: "Tùy chỉnh",
};

export function formatPaper(p: CurrentPaper | null | undefined): string {
  if (!p) return "Theo template";
  const size = PAPER_LABELS[p.paperSize] ?? p.paperSize;
  const orient = p.orientation === "landscape" ? "ngang" : "dọc";
  if (p.paperSize === "Custom" && p.customMm) {
    return `${p.customMm.width}×${p.customMm.height}mm ${orient}`;
  }
  return `${size} ${orient}`;
}
